import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id")({
  staticData: {
    title: "apps.resources",
  },
});
